<template>
  <div class="row" align="center" id="seccion_botones">
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                requerimiento.link.includes('scorm') &&
                permitirMaterial &&
                requerimiento.prerrequisito == 0
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            data-trigger="hover"
            data-placement="bottom"
            data-container="body"
            data-toggle="popover"
            title="Iniciar curso"
            :id="'estudiarScorm' + requerimiento.tema_institucional"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('EstudiarScorm');
              }
            "
          >
            <i class="fas fa-laptop"></i>
          </button>
        </div>
      </div>
      <div
        :class="
          'row textUnder ' +
            !(
              requerimiento.link.includes('scorm') &&
              permitirMaterial &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        CURSO
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                requerimiento.material &&
                permitirMaterial &&
                requerimiento.prerrequisito == 0
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            data-trigger="hover"
            data-placement="bottom"
            data-container="body"
            data-toggle="popover"
            title="Ver material / Tomar curso"
            :id="'verMaterial' + requerimiento.tema_institucional"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('VerMaterial');
              }
            "
          >
            <i class="fas fa-file-alt"></i>
          </button>
        </div>
      </div>
      <div
        :class="
          'row textUnder ' +
            !(
              requerimiento.material &&
              permitirMaterial &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        MATERIAL
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            v-if="requerimiento.confirmado != 1"
            :disabled="
              !(
                usuario.usuario_sistema != 'Instructor' &&
                requerimiento.calificacion == null &&
                requerimiento.cve_inscripcion_ai != null &&
                requerimiento.confirmado == 0 &&
                requerimiento.prerrequisito == 0
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            data-trigger="hover"
            data-placement="bottom"
            data-container="body"
            data-toggle="popover"
            title="Confirmar Asistencia"
            :id="'confirmarAsistenciaB' + requerimiento.tema_institucional"
            href=""
            @click="ConfirmarAsistencia"
          >
            <i
              v-if="
                requerimiento.cargando_confirmar_asistencia &&
                  requerimiento.prerrequisito == 0
              "
              class="fas fa-circle-notch fa-spin"
            />
            <i v-else class="fas fa-clipboard-check"></i>
          </button>
          <button v-else type="button"
          disabled
            class="btn waves-effect waves-light btn-info no-action"
            data-trigger="hover"
            data-placement="bottom"
            data-container="body"
            data-toggle="popover"
            title="Asistencia confirmada"
            :id="'confirmarAsistenciaB' + requerimiento.tema_institucional"
            href="">
            <i class="fas fa-check"></i>
          </button>
        </div>
      </div>
      <div
        :class="
          'confirm row textUnder ' +
            !(
              usuario.usuario_sistema != 'Instructor' &&
              requerimiento.calificacion == null &&
              requerimiento.cve_inscripcion_ai != null &&
              requerimiento.confirmado == 0 &&
              requerimiento.prerrequisito == 0
            )
        "
      >
        ASISTENCIA
      </div>
    </div>
    <div class="col container botButtons" align="center">
      <div class="row">
        <div class="col-auto">
          <button
            :disabled="
              !(
                (requerimiento.accion.includes('presentar_examen') ||
                  requerimiento.presentar_examen) &&
                permitirMaterial &&
                requerimiento.prerrequisito == '0' &&
                (requerimiento.intentos_disponibles != null &&
                  requerimiento.intentos < requerimiento.intentos_disponibles)
              )
            "
            type="button"
            class="btn waves-effect waves-light btn-info"
            data-trigger="hover"
            data-placement="bottom"
            data-container="body"
            data-toggle="popover"
            title="Presentar examen"
            :id="'presentarExamenB' + requerimiento.tema_institucional"
            href=""
            @click="
              () => {
                desactivarPopovers();
                $emit('PresentarExamen');
              }
            "
          >
            <i class="fas fa-edit"></i>
          </button>
        </div>
      </div>
      <div
        :class="
          'row textUnder ' +
            !(
              (requerimiento.accion.includes('presentar_examen') ||
                requerimiento.presentar_examen) &&
              permitirMaterial &&
              requerimiento.prerrequisito == '0' &&
              (requerimiento.intentos_disponibles != null &&
                requerimiento.intentos < requerimiento.intentos_disponibles)
            )
        "
      >
        EXAMEN
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["requerimiento"],
  data() {
    return {
      permitirMaterial: false,
      tipo: "Planeada"
    };
  },
  methods: {
    ...mapActions({
      compareDates: "compararContraHoy"
    }),
    desactivarPopovers() {
      $(".popover").popover("hide");
    },
    ConfirmarAsistencia() {
      this.requerimiento.cargando_confirmar_asistencia = true;
      this.$http
        .post("mobile/cursos/confirmar_asistencia", {
          cve_inscripcion_ai: this.requerimiento.cve_inscripcion_ai
        })
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          if (respuestaJson.resp == "Excelente") {
            this.requerimiento.confirmado = 1;
          } else {
            swal(respuestaJson.resp, "", "error");
          }
        })
        .catch(error => {
          swal("Error", "Problemas para confirmar Asistencia", "error");
        })
        .finally(response => {
          this.requerimiento.cargando_confirmar_asistencia = false;
          $(".popover").popover("hide");
        });
    }
  },
  created() {
    console.log(this.requerimiento);
    if (this.requerimiento.cve_curso) {
      this.$http
        .get("cursos/by/id/" + this.requerimiento.cve_curso)
        .then(respuesta => {
          if (respuesta.body.length > 0) {
            try {
              let year = this.requerimiento.fecha_curso.split("-")[0];
              let month = this.requerimiento.fecha_curso.split("-")[1];
              let day = this.requerimiento.fecha_curso.split("-")[2];
              let date1 = new Date(year, month - 1, day, 0, 0, 0);
              let date2 = new Date(
                year,
                month - 1,
                Number(day) + Number(respuesta.body[0].dias_acceso),
                23,
                59,
                59
              );
              if (this.compareDates({ dateIni: date1, dateFin: date2 })) {
                this.permitirMaterial = true;
              } else {
                this.permitirMaterial = false;
              }
            } catch (er) {
              console.error("it's not a date");
            }
          }
        })
        .finally(() => {
          $(window).ready(() => {
            $('[data-toggle="popover"]').popover();
          });
        });
      if (this.requerimiento.link.includes("scorm")) {
        this.permitirMaterial = true;
      }
    } else {
      this.permitirMaterial = false;
    }
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    }
  },
  mounted() {
    $('[data-toggle="popover"]').popover();
  },
  watch: {
    permitirMaterial() {
      $('[data-toggle="popover"]').popover();
    }
  }
};
</script>

<style scoped>
.botButtons {
  padding: 0;
  margin: -0.5px;
}

.botButtons button {
  color: grey;
  background-color: rgba(148, 148, 148, 0.308);
  border: none;
  max-width: 3em;
  width: 40px;
}
.textUnder {
  font-size: 0.8em;
  text-align: center;
  font-weight: 500;
}

button:disabled {
  cursor: default;
  background-color: rgba(201, 198, 198, 0.356);
  color: rgba(201, 198, 198, 0.685);
}

.textUnder.true {
  color: rgba(201, 198, 198, 0.685);
}

.botButtons > .row {
  width: min-content;
}
.confirm {
  padding-top: 0.15em;
  font-size: 0.7em;
}

.btn {
  font-size: 1.5em;
  padding: 0;
}
.no-action:disabled{
  color: green;
  background-color:rgba(148, 148, 148, 0.308);
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Tabs/actionsCol.vue